import React from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import tenantConfig from 'config/tenant'
import { Button } from 'shared/atoms'
import { ReactComponent as PhoneIcon } from 'assets/shared/icons/phone.svg'
import './navbar.scss'

const Navbar: React.FC = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const isOnSupportPage = location.pathname === '/support'
  const { name, logo, supportPhone } = tenantConfig

  return (
    <nav className="navbar">
      <div className="navbar__inner">
        <button
          className="navbar__brand"
          onClick={() => navigate('/')}
          type="button"
        >
          <img src={logo} alt={name} className="navbar__logo" />
          <span className="navbar__name">{name}</span>
        </button>

        <div className="navbar__actions">
          {supportPhone && (
            <a href={`tel:${supportPhone}`} className="navbar__phone">
              <PhoneIcon />
              {supportPhone}
            </a>
          )}
          {!isOnSupportPage && (
            <button
              className="navbar__link"
              onClick={() => navigate('/support')}
              type="button"
            >
              Support
            </button>
          )}
          <Button
            appearance="primary"
            className="navbar__cta"
            onClick={() => navigate('/login')}
          >
            Sign In
          </Button>
        </div>
      </div>
    </nav>
  )
}

export default Navbar
